// ========================================
// COMPONENTS / AboutUs.jsx — Moon Berry
// ========================================

import React from "react";
import styles from "./AboutUs.module.css";

export default function AboutUs() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>

        {/* Left — image */}
        <div className={styles.imageWrap}>
          <img
            src="/ABOUT-US-FINAL.png"
            alt="About Moon Berry"
            className={styles.image}
          />
        </div>

        {/* Right — text */}
        <div className={styles.content}>
          <p className={styles.label}>Our Story</p>
          <h2 className={styles.title}>
            About <span className={styles.brand}>Moon Berry</span>
          </h2>
          <div className={styles.divider} />

          <p className={styles.body}>
            Moon Berry is more than just a brand — it is a little world created
            with <strong>love, creativity, and elegance</strong>. Founded by{" "}
            <strong>Kanchan Katara</strong> and <strong>Aashima Mehta</strong>,
            two visionary entrepreneurs based in Dubai, Moon Berry was born from
            a shared belief that everyday products should bring joy, reflect
            personality, and celebrate life's special moments.
          </p>

          <p className={styles.body}>
            From trendy stationery and stylish accessories to thoughtfully
            curated gift hampers — every product is handpicked with care and
            love. We believe the little things in life carry the greatest joy,
            and that gifting should always feel meaningful and memorable.
          </p>

          <p className={styles.body}>
            Our mission is simple: to offer <strong>unique, high-quality,
            and beautifully curated products</strong> that make everyday life
            more special, one gift at a time.
          </p>

          <p className={styles.closing}>
            Thank you for being a part of the <strong>Moon Berry</strong> family.
            Together, let's make every celebration brighter, every gift more
            special, and every day a little cuter. 🌙🍓
          </p>
        </div>

      </div>
    </section>
  );
}
